import { render, staticRenderFns } from "./CreateTrophy.vue?vue&type=template&id=f3fd95c6&"
import script from "./CreateTrophy.vue?vue&type=script&lang=js&"
export * from "./CreateTrophy.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./CreateTrophy.vue?vue&type=style&index=1&id=f3fd95c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports